import React from "react";
import * as Mui from "@mui/material";
import * as Icons from "react-feather";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { FeatherIcon } from "component/shared/feather-icon";
import { aiSessionIdDev } from "shared/env";
import { styles } from "./style";

interface Props extends WithStyles<typeof styles> {
	aiSessionIds: number[];
}

interface State {
	copied: boolean;
}

/**
 * The Search Agent session ids behind a stretch of conversation, for test and product to send to
 * engineering. Renders only in builds with the `aiSessionIdDev` flag, and only when there is an id.
 */
class Component extends React.Component<Props, State> {

	public state: State = {
		copied: false,
	};

	public render() {
		const { aiSessionIds, classes = {} } = this.props;
		const { copied } = this.state;
		if (!aiSessionIdDev || !aiSessionIds.length) {
			return null;
		}
		return (
			<span className={classes.root} onClick={(event) => event.stopPropagation()}>
				{aiSessionIds.length === 1 ? "Session " : "Sessions "}
				{aiSessionIds.join(", ")}
				<Mui.Tooltip title={copied ? "Copied" : "Copy"}>
					<Mui.IconButton
						className={classes.copyButton}
						onClick={this.handleCopy}
						aria-label="Copy session id"
						size="small"
					>
						<FeatherIcon className={classes.copyIcon}>
							{copied ? <Icons.Check /> : <Icons.Copy />}
						</FeatherIcon>
					</Mui.IconButton>
				</Mui.Tooltip>
			</span>
		);
	}

	// The write can be refused (no permission, insecure context), so report success only once it
	// resolves. The ids stay on screen and selectable either way.
	private handleCopy = async () => {
		try {
			await navigator.clipboard.writeText(this.props.aiSessionIds.join(", "));
			this.setState({ copied: true });
		} catch{
			this.setState({ copied: false });
		}
	};
}

export const AiSessionIds = withStyles(Component, styles);
